import React, { Fragment, Component } from "react";
import PropertyImageVizSensor from "./PropertyImageVizSensor";
import { propertyUtil } from "../../PropertyUtil";
import noImage from "../../../../_img/not-available.png";
import PropertyImageSliderDialog from "./PropertyImageSliderDialog";
import { Typography } from '@mui/material';
import { renderLogicUtil } from "views/Pma/RenderLogicUtil";
import PropertyUrlViewDialog from "./PropertyUrlViewDialog";
import palette from "theme/palette";

const PhotoView = props => {
  const {
    isPropertyMapped,
    propertyDetails,
    mailingDetails,
    listingStatus,
    openMediaViewDialog,
    property,
    propertySequenceNumber,
    agentData,
  } = props;

  //get prop photo
  let propPhoto =
    isPropertyMapped && propertyDetails.photos
      ? propertyDetails.photos[0]
      : null;
  //get propview and main view
  let propView =
    propertyDetails && propertyDetails.view ? propertyDetails.view : [];
  let mainView = propertyUtil.getPropView(propView);
  const isADU = renderLogicUtil.isPropertyIsADU(property);
  const expandedPropertyType = renderLogicUtil.getPropertyType(property);
  // Anything other than Single Family (condo, townhouse, ...) is called out as a chip
  const isNonSingleFamily =
    !!expandedPropertyType && !/single\s*family/i.test(expandedPropertyType);
  return (
    <div className="global-ps-body-container tableTdFlex">
      <div className="tableTdFlex-First textCursor">
        <div>
          {/* {!isPropertyMapped || propPhoto === null ? (
            <div className="no-image-available-section">
              No Image
              <br />
              Available
            </div>
          ) : null} */}
          <div>
            {/* {listingStatus && listingStatus !== "Sold" ? (
              <div>Status: {listingStatus}</div>
            ) : (
              ""
            )} */}
          </div>
          {/* //isPropertyMapped. used true instead of this */}
          {true ? (
            <div>
              {/* <div>
                {propertyDetails &&
                  propertyDetails.propertySubtype === "Single Family Home"
                  ? "Single Family"
                  : propertyDetails.propertySubtype}
              </div> */}
              <div>
                Beds:{" "}
                {propertyDetails && propertyDetails.beds > 0
                  ? Number(propertyDetails.beds)
                  : mailingDetails && mailingDetails.BedRooms > 0
                    ? Number(mailingDetails.BedRooms)
                    : mailingDetails && mailingDetails.Bedrooms > 0
                      ? Number(mailingDetails.Bedrooms)
                      : "---"}
                , Baths:{" "}
                {mailingDetails && mailingDetails.Bathfull > 0
                  ? Number(mailingDetails.Bathfull) +
                  (propertyDetails.halfBaths > 0 ? "+" : "")
                  : mailingDetails && mailingDetails.Baths > 0
                    ? parseInt(mailingDetails.Baths) +
                    (propertyDetails.halfBaths > 0 ? "+" : "")
                    : "---"}
              </div>
              <div>
                {propertyDetails &&
                  propertyDetails.squareFeet &&
                  propertyDetails.squareFeet > 0 &&
                  !isNaN(Number(propertyDetails.squareFeet))
                  ? `${Number(propertyDetails.squareFeet)} SqFt`
                  : mailingDetails &&
                    mailingDetails.Totalsf &&
                    mailingDetails.Totalsf > 0 &&
                    !isNaN(Number(mailingDetails.Totalsf))
                    ? `${Number(mailingDetails.Totalsf)} SqFt`
                    : ""}
              </div>
              {mainView && <div>View: {mainView}</div>}
              {expandedPropertyType && (
                <div style={{marginTop: '8px', marginBottom: (isADU ? 0 : '16px')}}>
                  {isNonSingleFamily ? (
                    <span
                      style={{
                        display: 'inline-block',
                        backgroundColor: palette.primary.main,
                        color: palette.common.white,
                        fontWeight: 600,
                        fontSize: '12px',
                        lineHeight: 1.4,
                        padding: '2px 8px',
                        borderRadius: '4px',
                      }}
                    >
                      {expandedPropertyType}
                    </span>
                  ) : (
                    <span style={{fontWeight: 600}}>{expandedPropertyType}</span>
                  )}
                </div>
              )}
              {isADU && <div variant="subtitle2" style={{marginBottom: '16px', fontWeight: 600,}}>+ ADU</div>}
            </div>
          ) : null}
        </div>
      </div>
      {/* {isPropertyMapped && propPhoto !== null ? */}
      <div style={{marginBottom: '8px', display: 'block'}}>
        <PropertyImageSliderDialog
          //src={propPhoto}
          //className="mailing-photo-thumbnail"
          //alt="Property Image"
          propertyDetails={propertyDetails}
          mailingDetails={mailingDetails}
          propertySequenceNumber={propertySequenceNumber}
          property={property}
          //noImageMode={!propPhoto}//isPropertyMapped && 
        />
        </div>
      <PropertyUrlViewDialog
        propertyDetails={propertyDetails}
        isPropertyMapped={isPropertyMapped}
        mailingDetails={mailingDetails}
        openMediaViewDialog={openMediaViewDialog}
        propertySequenceNumber={propertySequenceNumber}
        property={property}
        agentData={agentData}
      />
    </div>
  );
};

export default PhotoView;
